import { Home } from "./home";
import { Dashboard } from "./dashboard";
import { Board } from "./Board";
import { Account } from "./Account";
import { AdminHome } from "./admin/AdminHome";
import { AdminUsers } from "./admin/Users";
import { AdminBoards } from "./admin/Boards";
import { annotateDebugComponents } from "../utils/dev_corner";

const Routes = [
  ["/", Home, "Home"],
  ["/dashboard", Dashboard, "Dashboard"],
  ["/boards/:id", Board, "Board"],
  ["/account", Account, "Account"],
];

const AdminRoutes = [
  ["/admin", AdminHome, "Admin"],
  ["/admin/users", AdminUsers, "Admin Users"],
  ["/admin/boards", AdminBoards, "Admin Boards"],
];

export const AppRoutes = annotateDebugComponents(
  (window as any).userAttrs.is_admin ? [...Routes, ...AdminRoutes] : Routes
);
